import { render } from "./DeliveryMenPage.vue?vue&type=template&id=4501ed54&scoped=true"
import script from "./DeliveryMenPage.vue?vue&type=script&lang=js"
export * from "./DeliveryMenPage.vue?vue&type=script&lang=js"

import "./DeliveryMenPage.vue?vue&type=style&index=0&id=4501ed54&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4501ed54"]])

export default __exports__